export default () => ({
  corporate: [],
  dependent: [],
  currentCorporate: {},
  currentDependent: {},
})
